import request from '@/utils/request'

//招标代理计算方式 3,4,5
export function bidCalculate(data) {
  return request({
    url: '/project/bid/ins',
    method: 'post',
    data: data
  })
}


//社会中介机构审计(查)费 7,8,10,11,14,16
export function bidSocialFees(data) {
  return request({
    url: '/project/record/ins',
    method: 'post',
    data: data
  })
}


export function supervisionService(data) {
  return request({
    url: '/project/supervision/insCalcSupervisionService',
    method: 'post',
    data: data
  })
}

export function QuotaValuation(data) {
  return request({
    url: '/project/quota/ins',
    method: 'post',
    data: data
  })
}



export function SettlementReview(data) {
  return request({
    url: '/project/settlement/ins',
    method: 'post',
    data: data
  })
}

export function getComplexity(data) {
  return request({
    url: '/project/complexity/list',
    method: 'get',
    params: data
  })
}

//设计费用
export function DesignService(data) {
  return request({
    url: '/project/fee/ins',
    method: 'post',
    data: data
  })
}

//监理
export function getServer(data) {
  return request({
    url: '/project/fee/jlfins',
    method: 'post',
    data: data
  })
}

//建设单位管理费
export function getConstructionManagement(data) {
  return request({
    url: '/project/administrativeResult/ins',
    method: 'post',
    data: data
  })
}

//环境影响评价费
export function gethjyxpjf(data) {
  return request({
    url: '/project/hjyxpj/ins',
    method: 'post',
    data: data
  })
}


//全国建设项目前期工作咨询费
export function getjsxmqqgzzxf(data) {
  return request({
    url: '/project/jsxmqqgzzxf/ins',
    method: 'post',
    data: data
  })
}

//水土保持费
export function getstbcf(data) {
  return request({
    url: '/project/stbcf/ins',
    method: 'post',
    data: data
  })
}

// 岩土工程设计收费
export function getytgcsjf(data) {
  return request({
    url: '/project/ytgcsj/ins',
    method: 'post',
    data: data
  })
}




//建设期利息计算
export function getjsqlx(data) {
  return request({
    url: '/project/jsqlx/ins',
    method: 'post',
    data: data
  })
}

//全国施工图审查费计算
export function getsgtscf(data) {
  return request({
    url: '/project/sgtscf/ins',
    method: 'post',
    data: data
  })
}


//全国施工图审查费计算
export function getdljsgcjnpgf(data) {
  return request({
    url: '/project/dljsgcshwdfxpgf/ins',
    method: 'post',
    data: data
  })
}

  //铺底流动资金计算
export function getpdldzj(data) {
  return request({
    url: '/project/pdldzj/ins',
    method: 'post',
    data: data
  })
}

   //生产准备费
export function getsczbf(data) {
  return request({
    url: '/project/sczbfgf/ins',
    method: 'post',
    data: data
  })
}

  //场地准备及临时设施费
export function getcdzbjlsssf(data) {
  return request({
    url: '/project/cdzb/ins',
    method: 'post',
    data: data
  })
}

//劳动安全卫生评审费
export function getldaqwsps(data) {
  return request({
    url: '/project/ldaqwsps/ins',
    method: 'post',
    data: data
  })
}


//全国电力建设工程安全卫生预评价费
export function getdljsgcaqwsypjf(data) {
  return request({
    url: '/project/dljsgcaqwsypjf/ins',
    method: 'post',
    data: data
  })
}


//全国电力建设工程地震安全性评价费
export function getdljsgcdzaqxpj(data) {
  return request({
    url: '/project/dljsgcdzaqxpj/ins',
    method: 'post',
    data: data
  })
}


//工程质量检查检测费(光伏发电工程)
export function getgczljcjcfgf(data) {
  return request({
    url: '/project/gczljcjcfgf/ins',
    method: 'post',
    data: data
  })
}

//项目验收费(光伏发电工程)
export function getxmysfgf(data) {
  return request({
    url: '/project/xmysfgf/ins',
    method: 'post',
    data: data
  })
}

//海域和无人岛金征费
//海域使用金征收标准
//
export function gethyjzf(data) {
  return request({
    url: '/project/hyjzf/ins',
    method: 'post',
    data: data
  })
}



//全国交通影响评价费
//
export function getjtyxpjf(data) {
  return request({
    url: '/project/jtyxpjf/ins',
    method: 'post',
    data: data
  })
}

//水利水电工程勘察
//
export function getslsdgc(data) {
  return request({
    url: '/project/slsdkc/ins',
    method: 'post',
    data: data
  })
}



//洞室测量费
//
export function getdsclf(data) {
  return request({
    url: '/project/dscl/ins',
    method: 'post',
    data: data
  })
}


//工程水域测量收费标准计算
//
export function getgcsycl(data) {
  return request({
    url: '/project/gcsyclsf/ins',
    method: 'post',
    data: data
  })
}








